import { isDevelopment, isLocal, isStaging } from 'UTILS/env';

export const partnerIntegrationsEnabled =
  isStaging() || isDevelopment() || isLocal();

/**
 * Object Builder constants
 */
export const FORM_FIELDS_PATH = '__fields';
export const FORM_SELECTED_FIELD_NAME_PATH = '__selectedFieldName';

export type FieldName = `${typeof FORM_FIELDS_PATH}.${string}`;
